import React from 'react';
import { Plus } from 'lucide-react';
import PropertyTable from '../shared/PropertyTable';

const DesktopPropertiesTab = ({ properties, onAddProperty, onPropertyClick }) => {
  return (
    <div className="max-w-6xl mx-auto space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-lg font-semibold text-notion-text">Property Hub</h2>
          <p className="text-xs text-stone-400">Manage listings and single-property sites.</p>
        </div>
        <button onClick={onAddProperty} className="flex items-center gap-2 px-3 py-1.5 bg-stone-800 text-white rounded text-xs font-medium hover:bg-stone-700 transition">
          <Plus className="w-3.5 h-3.5" /> Add Property
        </button>
      </div>

      <PropertyTable 
        properties={properties} 
        onPropertyClick={onPropertyClick}
      />
    </div>
  );
};

export default DesktopPropertiesTab;
